import React, { useState, useEffect } from 'react';
import Layout from './Layout';
import axios from 'axios';
import { useTheme } from '../context/ThemeContext';
import Swal from 'sweetalert2';

function ComposeSMS() {
  const { isDark } = useTheme();
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [scheduleDate, setScheduleDate] = useState('');
  const [scheduleTime, setScheduleTime] = useState('');
  const [smsCategory, setSmsCategory] = useState('');
  const [selectedService, setSelectedService] = useState('Termii');
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [showBulk, setShowBulk] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);

  const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://rccgtr.net/api';

  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true
  });

  useEffect(() => {
    loadTemplates();
  }, []);

  const loadTemplates = async () => {
    try {
      const { data } = await axios.get(`${API_BASE_URL}/sms/templates`);
      if (data.success) {
        setTemplates(data.data);
      }
    } catch (error) {
      console.error('Error loading templates:', error);
    }
  };

  // SMS Templates for different purposes
  const smsTemplates = {
    firstTime: "Welcome to our church! We're glad you joined us today. God bless you!",
    returning: "Welcome back! We're excited to see you again this Sunday. God bless!",
    sundayReminder: "Reminder: Sunday service starts at 9:00 AM. We look forward to seeing you!",
    midweekReminder: "Midweek service reminder: Wednesday Bible study at 6:00 PM. Join us!",
    birthday: "Happy Birthday! May God bless you abundantly on your special day.",
    custom: ""
  };

  const handleTemplateChange = (template) => {
    setSelectedTemplate(template);
    if (template !== 'custom') {
      setMessage(smsTemplates[template]);
    } else {
      setMessage('');
    }
  };

  const sendSms = async () => {
    if (!phone || !message) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...!',
        text: 'Please fill in both phone number and message.',
        timer: 2000,
        showConfirmButton: false
      });
      //alert('Please fill in both phone number and message');
      return;
    }

    setSending(true);

    try {
      const { data } = await axios.post(`${API_BASE_URL}/sms/send`, {
        phone,
        message,
        category: smsCategory || 'General'
      }, { headers: { 'Content-Type': 'application/json' } });

      if (data.success) {
        // alert('✅ SMS sent successfully!');
        Toast.fire({
        icon: 'success',
        title: '✅ SMS sent successfully!'
      });
        setPhone('');
        setMessage('');
        setSelectedTemplate('');
      } else {
        Toast.fire({
          icon: 'error',
          title: `❌ Failed to send SMS: ${data.error || 'Unknown error'}`
        });
        // alert(`❌ Failed to send SMS: ${data.error || 'Unknown error'}`);
      }
    } catch (error) {
      Toast.fire({
        icon: 'error',
        title: `❌ Network or server error: ${error.message}`
      });
      // alert(`❌ Network or server error: ${error.message}`);
      console.error('Error details:', error);
    } finally {
      setSending(false);
    }
  };

  const scheduleSms = async () => {
    if (!phone || !message || !scheduleDate || !scheduleTime) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...!',
        text: 'Please fill in all required fields for scheduling',
        timer: 2000,
        showConfirmButton: false
      });
      // alert('Please fill in all required fields for scheduling');
      return;
    }

    const scheduledDateTime = new Date(`${scheduleDate}T${scheduleTime}`);
    const now = new Date();

    if (scheduledDateTime <= now) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...!',
        text: 'Please select a future date and time',
        timer: 2000,
        showConfirmButton: false
      });
      // alert('Please select a future date and time');
      return;
    }

    try {
      const { data } = await axios.post(`${API_BASE_URL}/sms/schedule`, {
        phone,
        message,
        category: smsCategory || 'General',
        scheduledFor: scheduledDateTime.toISOString()
      }, { headers: { 'Content-Type': 'application/json' } });

      if (data.success) {
        Toast.fire({
          icon: 'success',
          title: '✅ SMS scheduled successfully!'
        });
        // alert('✅ SMS scheduled successfully!');
        setPhone('');
        setMessage('');
        setScheduleDate('');
        setScheduleTime('');
        setSelectedTemplate('');
      } else {
        Toast.fire({
          icon: 'error',
          title: `❌ Failed to schedule SMS: ${data.error || 'Unknown error'}`
        });
        // alert(`❌ Failed to schedule SMS: ${data.error || 'Unknown error'}`);
      }
    } catch (error) {
      Toast.fire({
        icon: 'error',
        title: `❌ Network or server error: ${error.message}`
      });
      // alert(`❌ Network or server error: ${error.message}`);
      console.error('Error details:', error);
    }
  };

  const sendBulkVisitorSMS = async (visitorType, templateId) => {
    if (!scheduleDate || !scheduleTime) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...!',
        text: 'Please select date and time for bulk SMS',
        timer: 2000,
        showConfirmButton: false
      });
      // alert('Please select date and time for bulk SMS');
      return;
    }

    const scheduledDateTime = new Date(`${scheduleDate}T${scheduleTime}`);
    const now = new Date();

    if (scheduledDateTime <= now) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...!',
        text: 'Please select a future date and time',
        timer: 2000,
        showConfirmButton: false
      });
      //  alert('Please select a future date and time');
      return;
    }

    setLoading(true);

    try {
      const { data } = await axios.post(`${API_BASE_URL}/sms/bulk/visitors`, {
        visitorType,
        templateId,
        scheduledFor: scheduledDateTime.toISOString()
      }, { headers: { 'Content-Type': 'application/json' } });

      if (data.success) {
        Toast.fire({
          icon: 'success',
          title: `✅ Bulk SMS scheduled successfully for ${data.data.scheduled} ${visitorType} visitors!`
        });
        // alert(`✅ Bulk SMS scheduled successfully for ${data.data.scheduled} ${visitorType} visitors!`);
        setScheduleDate('');
        setScheduleTime('');
      } else {
        Toast.fire({
          icon: 'error',
          title: `❌ Failed to schedule bulk SMS: ${data.error || 'Unknown error'}`
        });
        // alert(`❌ Failed to schedule bulk SMS: ${data.error || 'Unknown error'}`);
      }
    } catch (error) {
      Toast.fire({
        icon: 'error',
        title: `❌ Network or server error: ${error.message}`
      });
      // alert(`❌ Network or server error: ${error.message}`);
      console.error('Error details:', error);
    } finally {
      setLoading(false);
    }
  };

  const sendBulkReminderSMS = async (reminderType, templateId) => {
    if (!scheduleDate || !scheduleTime) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...!',
        text: 'Please select date and time for bulk SMS',
        timer: 2000,
        showConfirmButton: false
      });
      // alert('Please select date and time for bulk SMS');
      return;
    }

    const scheduledDateTime = new Date(`${scheduleDate}T${scheduleTime}`);
    const now = new Date();

    if (scheduledDateTime <= now) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...!',
        text: 'Please select a future date and time',
        timer: 2000,
        showConfirmButton: false
      });
      // alert('Please select a future date and time');
      return;
    }

    setLoading(true);

    try {
      const { data } = await axios.post(`${API_BASE_URL}/sms/bulk/reminders`, {
        reminderType,
        templateId,
        scheduledFor: scheduledDateTime.toISOString()
      }, { headers: { 'Content-Type': 'application/json' } });

      if (data.success) {
        Toast.fire({
          icon: 'success',
          title: `✅ Bulk SMS scheduled successfully for ${data.data.scheduled} ${reminderType} reminders!`
        });
        // alert(`✅ Bulk SMS scheduled successfully for ${data.data.scheduled} ${reminderType} reminders!`);
        setScheduleDate('');
        setScheduleTime('');
      } else {
        Toast.fire({
          icon: 'error',
          title: `❌ Failed to schedule bulk SMS: ${data.error || 'Unknown error'}`
        });
        // alert(`❌ Failed to schedule bulk SMS: ${data.error || 'Unknown error'}`);
      }
    } catch (error) {
      Toast.fire({
        icon: 'error',
        title: `❌ Network or server error: ${error.message}`
      });
      //   alert(`❌ Network or server error: ${error.message}`);
      console.error('Error details:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout title="Compose SMS">
      <div className="max-w-4xl mx-auto">
        {/* Main SMS Composition Form */}
        <div className={`rounded-xl shadow-lg p-6 mb-6 ${
          isDark ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'
        }`}>
          <h2 className="text-xl font-semibold mb-4">Compose New SMS</h2>
          
          {/* Phone Number Input */}
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">Phone Number</label>
            <input
              type="tel"
              placeholder="Enter phone number (e.g., 07012345678)"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className={`w-full px-4 py-2 rounded-lg border focus:ring-2 focus:ring-indigo-500 focus:border-transparent ${
                isDark 
                  ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                  : 'bg-white border-gray-300 text-gray-900 placeholder-gray-500'
              }`}
            />
          </div>

          {/* SMS Template Selection */}
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">SMS Template</label>
            <select
              value={selectedTemplate}
              onChange={(e) => handleTemplateChange(e.target.value)}
              className={`w-full px-4 py-2 rounded-lg border focus:ring-2 focus:ring-indigo-500 focus:border-transparent ${
                isDark 
                  ? 'bg-gray-700 border-gray-600 text-white' 
                  : 'bg-white border-gray-300 text-gray-900'
              }`}
            >
              <option value="">Select a template</option>
              <option value="firstTime">First Time Visitor</option>
              <option value="returning">Returning Member</option>
              <option value="sundayReminder">Sunday Service Reminder</option>
              <option value="midweekReminder">Midweek Service Reminder</option>
              <option value="birthday">Birthday Greeting</option>
              <option value="custom">Custom Message</option>
            </select>
          </div>

          {/* Message Input */}
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">Message</label>
            <textarea
              placeholder="Type your message here..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={4}
              className={`w-full px-4 py-2 rounded-lg border focus:ring-2 focus:ring-indigo-500 focus:border-transparent resize-none ${
                isDark 
                  ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                  : 'bg-white border-gray-300 text-gray-900 placeholder-gray-500'
              }`}
            />
            <div className="text-sm text-gray-500 mt-1">
              Characters: {message.length}/160
            </div>
          </div>

          {/* SMS Category */}
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">SMS Category</label>
            <select
              value={smsCategory}
              onChange={(e) => setSmsCategory(e.target.value)}
              className={`w-full px-4 py-2 rounded-lg border focus:ring-2 focus:ring-indigo-500 focus:border-transparent ${
                isDark 
                  ? 'bg-gray-700 border-gray-600 text-white' 
                  : 'bg-white border-gray-300 text-gray-900'
              }`}
            >
              <option value="">Select category</option>
              <option value="sunday_reminder">Sunday Service Reminder</option>
              <option value="midweek_reminder">Midweek Service Reminder</option>
              <option value="birthday">Birthday</option>
              <option value="announcement">Announcement</option>
              <option value="general">General</option>
            </select>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={sendSms}
              disabled={sending}
              className="flex-1 bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-medium transition-colors disabled:opacity-50"
            >
              {sending ? 'Sending...' : 'Send SMS Now'}
            </button>
            
            <button
              onClick={() => setShowAdvanced(!showAdvanced)}
              className="px-6 py-3 border border-indigo-600 text-indigo-600 hover:bg-indigo-50 rounded-lg font-medium transition-colors"
            >
              {showAdvanced ? 'Hide Advanced' : 'Advanced Options'}
            </button>

            <button
              onClick={() => setShowBulk(!showBulk)}
              className="px-6 py-3 border border-purple-600 text-purple-600 hover:bg-purple-50 rounded-lg font-medium transition-colors"
            >
              {showBulk ? 'Hide Bulk' : 'Bulk SMS'}
            </button>
          </div>
        </div>

        {/* Bulk SMS Section */}
        {showBulk && (
          <div className={`rounded-xl shadow-lg p-6 mb-6 ${
            isDark ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'
          }`}>
            <h3 className="text-lg font-semibold mb-4">Bulk SMS for Visitors & Members</h3>
            
            {/* Date and Time Selection */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium mb-2">Schedule Date</label>
                <input
                  type="date"
                  value={scheduleDate}
                  onChange={(e) => setScheduleDate(e.target.value)}
                  min={new Date().toISOString().split('T')[0]}
                  className={`w-full px-4 py-2 rounded-lg border focus:ring-2 focus:ring-indigo-500 focus:border-transparent ${
                    isDark 
                      ? 'bg-gray-700 border-gray-600 text-white' 
                      : 'bg-white border-gray-300 text-gray-900'
                  }`}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">Schedule Time</label>
                <input
                  type="time"
                  value={scheduleTime}
                  onChange={(e) => setScheduleTime(e.target.value)}
                  className={`w-full px-4 py-2 rounded-lg border focus:ring-2 focus:ring-indigo-500 focus:border-transparent ${
                    isDark 
                      ? 'bg-gray-700 border-gray-600 text-white' 
                      : 'bg-white border-gray-300 text-gray-900'
                  }`}
                />
              </div>
            </div>

            {/* Bulk SMS Options */}
            <div className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Visitor Bulk SMS */}
                <div className={`p-4 rounded-lg border ${
                  isDark ? 'border-gray-600 bg-gray-700' : 'border-gray-300 bg-gray-50'
                }`}>
                  <h4 className="font-medium mb-3">Visitor Welcome Messages</h4>
                  <div className="space-y-2">
                    <button
                      onClick={() => sendBulkVisitorSMS('first_timer', 1)}
                      disabled={loading || !scheduleDate || !scheduleTime}
                      className="w-full px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors disabled:opacity-50"
                    >
                      {loading ? 'Scheduling...' : 'Schedule First Timer SMS'}
                    </button>
                    <button
                      onClick={() => sendBulkVisitorSMS('returning_member', 2)}
                      disabled={loading || !scheduleDate || !scheduleTime}
                      className="w-full px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium transition-colors disabled:opacity-50"
                    >
                      {loading ? 'Scheduling...' : 'Schedule Returning Member SMS'}
                    </button>
                  </div>
                </div>

                {/* Service Reminder Bulk SMS */}
                <div className={`p-4 rounded-lg border ${
                  isDark ? 'border-gray-600 bg-gray-700' : 'border-gray-300 bg-gray-50'
                }`}>
                  <h4 className="font-medium mb-3">Service Reminders</h4>
                  <div className="space-y-2">
                    <button
                      onClick={() => sendBulkReminderSMS('sunday', 3)}
                      disabled={loading || !scheduleDate || !scheduleTime}
                      className="w-full px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg font-medium transition-colors disabled:opacity-50"
                    >
                      {loading ? 'Scheduling...' : 'Schedule Sunday Reminder SMS'}
                    </button>
                    <button
                      onClick={() => sendBulkReminderSMS('midweek', 4)}
                      disabled={loading || !scheduleDate || !scheduleTime}
                      className="w-full px-4 py-2 bg-orange-600 hover:bg-orange-700 text-white rounded-lg font-medium transition-colors disabled:opacity-50"
                    >
                      {loading ? 'Scheduling...' : 'Schedule Midweek Reminder SMS'}
                    </button>
                  </div>
                </div>
              </div>

              <div className="text-sm text-gray-600 dark:text-gray-400 text-center">
                💡 These bulk SMS will be sent to all registered visitors and members based on the SMS Category Timing Settings
              </div>
            </div>
          </div>
        )}

        {/* Advanced Options */}
        {showAdvanced && (
          <div className={`rounded-xl shadow-lg p-6 mb-6 ${
            isDark ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'
          }`}>
            <h3 className="text-lg font-semibold mb-4">Advanced Options</h3>
            
            {/* Schedule SMS */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium mb-2">Schedule Date</label>
                <input
                  type="date"
                  value={scheduleDate}
                  onChange={(e) => setScheduleDate(e.target.value)}
                  min={new Date().toISOString().split('T')[0]}
                  className={`w-full px-4 py-2 rounded-lg border focus:ring-2 focus:ring-indigo-500 focus:border-transparent ${
                    isDark 
                      ? 'bg-gray-700 border-gray-600 text-white' 
                      : 'bg-white border-gray-300 text-gray-900'
                  }`}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">Schedule Time</label>
                <input
                  type="time"
                  value={scheduleTime}
                  onChange={(e) => setScheduleTime(e.target.value)}
                  className={`w-full px-4 py-2 rounded-lg border focus:ring-2 focus:ring-indigo-500 focus:border-transparent ${
                    isDark 
                      ? 'bg-gray-700 border-gray-600 text-white' 
                      : 'bg-white border-gray-300 text-gray-900'
                  }`}
                />
              </div>
            </div>

            <button
              onClick={scheduleSms}
              disabled={!scheduleDate || !scheduleTime}
              className="w-full bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-3 rounded-lg font-medium transition-colors disabled:opacity-50"
            >
              Schedule SMS
            </button>
          </div>
        )}

        {/* SMS Service Configuration Info */}
        <div className={`rounded-xl shadow-lg p-6 ${
          isDark ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'
        }`}>
          <h3 className="text-lg font-semibold mb-4">SMS Service Configuration</h3>
          <div className="space-y-3">
            <div className="p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
              <p className="text-sm">
                <strong>Current Service:</strong> {selectedService}
              </p>
              <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">
                Configure your SMS service API keys in the Settings module
              </p>
            </div>
            <div className="p-3 bg-green-50 dark:bg-green-900/20 rounded-lg">
              <p className="text-sm">
                <strong>Bulk SMS Feature:</strong> Automatically send welcome messages to new visitors and service reminders to members
              </p>
              <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">
                The system will use your visitor registration data to send personalized messages
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default ComposeSMS;
